{
  "name": "client-portal-app",
  "version": "0.0.0",
  "files": [
    "dist/**"
  ],
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration development",
    "start:noApi": "ng serve --configuration development-noApi",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --browsers=Chrome --watch",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadlessCI --code-coverage",
    "test:coverage": "ng test --code-coverage --source-map --watch=false"
  },
  "private": false,
  "dependencies": {
    "@angular/animations": "^19.1.0",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/platform-server": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@grafana/faro-core": "^1.13.3",
    "@grafana/faro-web-sdk": "^1.13.3",
    "@grafana/faro-web-tracing": "^1.13.3",
    "@ips/common-angular": "^19.1.3-snapshot.202503261403",
    "@ngrx/effects": "^19.0.0",
    "@ngrx/entity": "^19.0.0",
    "@ngrx/store": "^19.0.0",
    "@ngrx/store-devtools": "^19.0.0",
    "@primeng/themes": "^19.0.5",
    "@sigstore/bundle": "^3.1.0",
    "@types/ws": "^8.5.14",
    "angular-oauth2-oidc": "^19.0.0",
    "angular-oauth2-oidc-jwks": "^17.0.2",
    "bootstrap": "^5.3.3",
    "com.trumbull.phx.casefile.api-client": "^1.0.0",
    "com.trumbull.phx.claim.api-client": "^1.1.1",
    "com.trumbull.phx.document.api-client": "^2.0.0",
    "com.trumbull.phx.order.api-client": "^1.0.0",
    "com.trumbull.phx.recordretrievalobjective.api-client": "^1.0.0",
    "com.trumbull.phx.vocabulary.api-client": "^1.0.0",
    "font-awesome-icons": "^1.6.0",
    "lodash": "^4.17.21",
    "ngx-toastr": "^19.0.0",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.5",
    "rxjs": "~7.8.0",
    "sass": "^1.83.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.1",
    "@angular/cli": "^19.1.4",
    "@angular/compiler-cli": "^19.2.1",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.14",
    "@types/node": "^18.18.0",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "typescript": "~5.7.2"
  }
}
